import { render } from "./CustomerVoice_M_1.vue?vue&type=template&id=d45fdd72"
import script from "./CustomerVoice_M_1.vue?vue&type=script&lang=js"
export * from "./CustomerVoice_M_1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__